import { Card, CardContent, CardHeader, CardTitle } from "@fox1ck-org/ui";

interface DiffPreviewProps {
  title: string;
  content: string;
  path: string;
}

export function DiffPreview({ title, content, path }: DiffPreviewProps) {
  return (
    <Card>
      <CardHeader className="pb-3 flex-row items-center justify-between">
        <CardTitle className="text-sm">{title}</CardTitle>
        <span className="text-xs text-muted-foreground font-mono">{path}</span>
      </CardHeader>
      <CardContent className="p-0">
        <pre className="p-4 text-xs text-foreground/80 font-mono overflow-auto max-h-96 bg-muted/30">
          {content}
        </pre>
      </CardContent>
    </Card>
  );
}
